import { useState } from "react";
import { ChevronDown } from "lucide-react";
import { useLang } from "@/App";
import { all, pick } from "@/data/images";
import Hero from "@/components/Hero";
import { Reveal, Pretitulo } from "@/components/Reveal";

export default function Faq() {
  const { t } = useLang();
  const p = t.faq;
  const [abierta, setAbierta] = useState(null);

  return (
    <div data-testid="pagina-faq">
      <Hero pre={p.hero.pre} titulo={p.hero.titulo} fotos={[pick(p.hero.foto[0], 0) || all(p.hero.foto[0])[0]]} testid="hero-faq" />

      <section className="py-20 md:py-28" data-testid="faq-intro">
        <div className="mx-auto max-w-2xl px-6 text-center md:px-10">
          <Reveal>
            <Pretitulo>{p.pre}</Pretitulo>
            <h2 className="mt-4 font-serif text-3xl font-light tracking-tight text-ink md:text-4xl">{p.titulo}</h2>
            <p className="mt-7 text-[15px] leading-relaxed text-ink-soft">{p.cuerpo}</p>
          </Reveal>
        </div>
      </section>

      <section className="pb-20 md:pb-28" data-testid="faq-listado">
        <div className="mx-auto max-w-3xl px-6 md:px-10">
          {p.items.map(([q, r], i) => (
            <Reveal key={q} delay={Math.min(i * 0.02, 0.25)} className="border-b border-lineas first:border-t" testid={`faq-item-${i + 1}`}>
              <button
                onClick={() => setAbierta(abierta === i ? null : i)}
                className="flex w-full items-center justify-between gap-6 py-6 text-left"
                data-testid={`faq-pregunta-${i + 1}`}
              >
                <span className="font-serif text-xl text-ink md:text-2xl">{q}</span>
                <ChevronDown size={20} strokeWidth={1.6} className={`shrink-0 text-terra transition-transform duration-300 ${abierta === i ? "rotate-180" : ""}`} />
              </button>
              {abierta === i && (
                <p className="-mt-1 pb-7 pr-10 text-[15px] leading-relaxed text-ink-soft" data-testid={`faq-respuesta-${i + 1}`}>{r}</p>
              )}
            </Reveal>
          ))}
        </div>
      </section>
    </div>
  );
}